'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DragDropContext = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDnd = require('react-dnd');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DragDropContext = exports.DragDropContext = function (_BcReactComponent) {
  _inherits(DragDropContext, _BcReactComponent);

  function DragDropContext() {
    _classCallCheck(this, DragDropContext);

    return _possibleConstructorReturn(this, (DragDropContext.__proto__ || Object.getPrototypeOf(DragDropContext)).apply(this, arguments));
  }

  _createClass(DragDropContext, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'cp-drag-drop-container' },
        this.props.children
      );
    }
  }]);

  return DragDropContext;
}(_baseBcReactComponent2.default);

DragDropContext.propTypes = {
  children: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node), _react2.default.PropTypes.node]).isRequired
};

exports.default = function (dragAndDropBackend) {
  return (0, _reactDnd.DragDropContext)(dragAndDropBackend)(DragDropContext);
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-drag-drop/lib/components/drag-drop-context/components/DragDropContext.component.js
// module id = 1182
// module chunks = 0